import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const StyledEmptyStateIcon = styled(SWReactIcons)`
    width: 120px;
    height: 64px;

    > svg {
        height: inherit;
        width: inherit;
    }
`;

export const StyledEmptyTitle = styled.div`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[500])};
`;

export const StyledEmptySubtitle = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
    text-align: center;
`;
